import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { map } from 'rxjs';
import { DatabaseQueries } from 'src/app/shared/types/get-query.enum';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { FilterListComponent } from 'src/app/shared/components/filter-list/filter-list.component';
import { WarehouseFilterService } from 'src/app/services/filters/warehouse-filter.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.component';
import { StyleMapper } from 'src/app/components/company/services/style-mapper';
import { Color, Gender, Size, Style, StyleFilters, StyleStatus } from 'src/app/components/company/models/new/style';
import * as _ from 'lodash';
import { Brand } from 'src/app/components/company/models/new/brand.model';
import { BrandFilterService } from 'src/app/services/filters/brand-filter.service';
import { StringFilterListComponent } from 'src/app/shared/components/string-filter-list/string-filter-list.component';
import { Status } from 'src/app/components/company/models/new/status';
import { OrderStatusFilterService } from 'src/app/services/filters/style-status-filter.service';
import { Selectable } from 'src/app/shared/types/selectable.type';
import { Warehouse } from 'src/app/shared/types/warehouse.model';
import { Paginable } from 'src/app/shared/types/paginable';
import { ManageColorsSizesModalComponent } from './manage-colors-sizes-modal/manage-colors-sizes-modal.component';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';
import { Category } from 'src/app/components/company/models/new/category';
import { StyleGroup } from 'src/app/components/company/models/new/style-group';
import { StyleDescription } from 'src/app/components/company/models/new/style-description';
import { Collection } from 'src/app/components/company/models/new/collection';
import { Purpose } from 'src/app/components/company/models/new/purpose';
import { Team } from 'src/app/components/company/models/new/team';
import { CategoryFilterService } from 'src/app/services/filters/category-filter.service';
import { StyleGroupFilterService } from 'src/app/services/filters/style-group-filter.service';
import { StyleDescriptionFilterService } from 'src/app/services/filters/style-description-filter.service';
import { CollectionFilterService } from 'src/app/services/filters/collection-filter.service';
import { PurposeFilterService } from 'src/app/services/filters/purpose-filter.service';
import { GenderFilterService } from 'src/app/services/filters/gender-filter.service';
import { TeamFilterService } from 'src/app/services/filters/team-filter.service';

@Component({
	selector: 'bt-add-product-modal',
	standalone: false,
	templateUrl: './add-product-modal.component.html',
	styleUrl: './add-product-modal.component.scss'
})
export class AddProductModalComponent implements OnInit {
	readonly #dialogRef = inject(MatDialogRef<AddProductModalComponent>);
	readonly #graphQLService = inject(GraphQLService);
	readonly #data = inject(MAT_DIALOG_DATA);

	availablestyles: Paginable<Selectable<Style>> = new Paginable<Selectable<Style>>();
	addedStyles: Selectable<Style>[] = [];
	stylesFilters: StyleFilters = new StyleFilters();
	styleStatus = StyleStatus;

	warehouse: Warehouse | null = null;
	warehouseDisabled = false;
	loadingStyles = false;

	loadingMore = false;
	allLoaded = false;

	isCustom = false;

	constructor(
		private dialog: MatDialog,
		private warehouseFilterService: WarehouseFilterService,
		private brandFilterService: BrandFilterService,
		private utilitiesService: UtilitiesService,
		private styleMapper: StyleMapper,
		private styleStatusFilterService: OrderStatusFilterService,
		private categoryFilterService: CategoryFilterService,
		private styleGroupFilterService: StyleGroupFilterService,
		private styleDescriptionFilterService: StyleDescriptionFilterService,
		private collectionFilterService: CollectionFilterService,
		private purposeFilterService: PurposeFilterService,
		private genderFilterService: GenderFilterService,
		private teamFilterService: TeamFilterService
	) {}

	ngOnInit() {
		this.isCustom = !!this.#data.isCustom;

		if (this.#data.warehouse) {
			this.warehouse = _.cloneDeep(this.#data.warehouse);
			this.warehouseDisabled = true;
		} else {
			this.warehouseDisabled = false;
		}

		if (this.warehouse || this.isCustom) {
			this.getStyles();
		}
	}

	/*getAddedStyles() {
		this.#graphQLService
			.getData<any>(DatabaseQueries.GET_SELECTED_STYLES, {
				//where: { ...this.styleMapper.toWhereClause(this.stylesFilters), warehouseArticles: { some: { freeStock: { gt: 0 } } } },
				where: this.styleMapper.toWhereClause(this.stylesFilters),
				...pagination
			})
			.pipe(
				map((res: any) => {
					const styles = res.data.styles;

					return {
						items: styles.nodes.map((node: any) => ({
							...this.styleMapper.toStyle(node),
							selected: false
						})),
						totalCount: styles.totalCount
					};
				})
			)
			.subscribe({
				next: (data) => {
					if (append) {
						this.availablestyles.items.push(...data.items);
					} else {
						this.availablestyles.items = data.items;
					}

					this.availablestyles.totalCount = data.totalCount;

					this.allLoaded = this.availablestyles.items.length >= data.totalCount;

					this.loadingStyles = false;
					this.loadingMore = false;
				},
				error: (err) => {
					this.loadingStyles = false;
					this.loadingMore = false;

					this.utilitiesService.showSnackbar('Error loading styles', SnackbarType.Error);

					console.error(err);
				}
			});
	}*/

	getStyles(append = false) {
		if (append) {
			this.loadingMore = true;
		} else {
			this.loadingStyles = true;
			this.availablestyles.currentPage = this.stylesFilters.page || 1;
			this.availablestyles.size = this.stylesFilters.size || 40;
		}

		const pagination = this.availablestyles.buildQuery(this.stylesFilters.page || 1);

		const query = this.isCustom ? DatabaseQueries.GET_STYLES_NO_STOCK : DatabaseQueries.GET_STYLES;
		const where: StyleFilters = {
			...this.stylesFilters,
			warehouses: !this.isCustom && this.warehouse ? [this.warehouse] : undefined
		};

		this.#graphQLService
			.getData<any>(query, {
				where: this.styleMapper.toWhereClause(where),
				...pagination
			})
			.pipe(
				map((res: any) => {
					const styles = this.isCustom ? res.data.stylesNoStock : res.data.styles;
					const _items: Selectable<Style>[] = styles.nodes.map((node: any) => ({
						...this.styleMapper.toStyle(node),
						selected: false
					}));

					//qui filto solo gli articoli che sono presenti nel magazzino selezionato
					// _items.forEach((style) => {
					// 	style.warehouseArticles = style.warehouseArticles?.filter((wa) => wa.warehouse?.id == this.warehouse?.id);
					// });

					return {
						items: _items,
						totalCount: styles.totalCount
					};
				})
			)
			.subscribe({
				next: (data) => {
					if (append) {
						this.availablestyles.items.push(...data.items);
					} else {
						this.availablestyles.items = data.items;
					}

					this.availablestyles.totalCount = data.totalCount;

					this.allLoaded = this.availablestyles.items.length >= data.totalCount;

					this.loadingStyles = false;
					this.loadingMore = false;
				},
				error: (err) => {
					this.loadingStyles = false;
					this.loadingMore = false;

					this.utilitiesService.showSnackbar('Error loading styles', SnackbarType.Error);

					console.error(err);
				}
			});
	}

	onStylesScroll(event: Event) {
		if (this.loadingStyles || this.loadingMore || this.allLoaded) {
			return;
		}

		const element = event.target as HTMLElement;

		const threshold = 200;

		const reachedBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - threshold;

		if (reachedBottom) {
			this.loadNextPage();
		}
	}

	loadNextPage() {
		if (this.availablestyles.items.length >= this.availablestyles.totalCount) {
			this.allLoaded = true;
			return;
		}

		this.stylesFilters.page = (this.stylesFilters.page || 1) + 1;

		this.getStyles(true);
	}

	selectStyle(style: Selectable<Style>) {
		style.selected = !style.selected;
	}

	selectAddedStyle(style: Selectable<Style>) {
		style.selected = !style.selected;
	}

	getSelectedStyles() {
		return this.availablestyles.items.filter((style) => style.selected);
	}

	getSelectedAddedStyles() {
		return this.addedStyles.filter((style) => style.selected);
	}

	toggleSelectAll() {
		const allSelected = this.availablestyles.items.filter((style) => style.selected && style.status?.id != this.styleStatus.Shooting).length == this.availablestyles.items.filter((style) => style.status?.id != this.styleStatus.Shooting).length;

		this.availablestyles.items
			.filter((style) => !this.isAdded(style))
			.forEach((style) => {
				style.selected = !allSelected;
				if (style.status?.id == this.styleStatus.Shooting) {
					style.selected = false;
				}
			});
	}

	toggleSelectAllAdded() {
		const allSelected = this.addedStyles.filter((style) => style.selected).length == this.addedStyles.length;
		this.addedStyles.forEach((style) => (style.selected = !allSelected));
	}

	addSelectedStyles() {
		this.getSelectedStyles().forEach((style) => {
			this.addStyle(style);
		});
	}

	addStyle(style: Selectable<Style>) {
		const copiedStyle = _.cloneDeep(style);

		if (!this.isCustom) {
			const warehouseArticles = copiedStyle.warehouseArticles ?? [];

			if (warehouseArticles.length) {
				const distinctColors = _.uniqBy(
					warehouseArticles.map((wa) => wa.color).filter((color) => !!color),
					'id'
				);
				copiedStyle.colors = distinctColors.map((color) => {
					const size = warehouseArticles.find((wa) => wa.color?.id === color?.id)?.size;
					return { ...color, size: size ? new Size({ id: size.id, name: size.name }) : undefined };
				});
			} else {
				copiedStyle.colors = copiedStyle.colors ?? [];
			}
		} else {
			const schemas = copiedStyle.schemas ?? [];
			const colorsFromSchemas: Color[] = [];

			schemas.forEach((schema) => {
				const firstSize = schema.schemaSizes?.[0];
				const size = firstSize ? new Size({ id: firstSize.sizeId, name: firstSize.sizeCode }) : undefined;
				const distinctColors = _.uniqBy(
					(schema.schemaTeamColors ?? []).filter((stc) => stc.colorId != null),
					'colorId'
				);

				distinctColors.forEach((stc) => {
					colorsFromSchemas.push(
						new Color({
							id: stc.colorId,
							code: stc.colorCode,
							name: stc.colorCode,
							size
						})
					);
				});
			});

			copiedStyle.colors = colorsFromSchemas.length ? _.uniqBy(colorsFromSchemas, 'id') : (copiedStyle.colors ?? []);
		}

		this.addedStyles.push({ ...copiedStyle, selected: false });

		const availableStyle = this.availablestyles.items.find((s) => s.code === style.code);
		if (availableStyle) {
			availableStyle.selected = false;
		}
	}

	isAdded(style: Style) {
		return this.addedStyles.some((s) => s.code === style.code);
	}

	removeSelectedStyles() {
		const selectedStyles = this.getSelectedAddedStyles();
		if (!selectedStyles.length) {
			return;
		}

		this.dialog
			.open(ConfirmModalComponent, {
				data: {
					title: 'Remove products',
					message: `Are you sure you want to remove ${selectedStyles.length} selected ${selectedStyles.length === 1 ? 'product' : 'products'}?`
				}
			})
			.afterClosed()
			.subscribe((confirmed: boolean) => {
				if (!confirmed) {
					return;
				}

				this.addedStyles = this.addedStyles.filter((style) => !selectedStyles.some((selected) => selected.code === style.code));
			});
	}

	removeStyle(style: Style) {
		this.dialog
			.open(ConfirmModalComponent, {
				data: {
					title: 'Remove product',
					message: `Are you sure you want to remove "${style.name || style.code}"?`
				}
			})
			.afterClosed()
			.subscribe((confirmed: boolean) => {
				if (!confirmed) {
					return;
				}

				this.addedStyles = this.addedStyles.filter((s) => s.code !== style.code);
			});
	}

	openManageColorsSizesModal(style: Style): void {
		this.dialog
			.open(ManageColorsSizesModalComponent, {
				data: { style, singleColorSelection: false, isCustom: this.isCustom }
			})
			.afterClosed()
			.subscribe({
				next: (res: { color: Selectable<Color>; sizesAndQuantity: Selectable<{ size: Size; availableQty: number }>[] }[]) => {
					if (res) {
						style.colors = res
							.filter((c) => c.color.selected)
							.map((c) => {
								const color = new Color({ id: c.color.id, code: c.color.code, name: c.color.name });
								const size = c.sizesAndQuantity.filter((s) => s.selected).map((s) => new Size({ id: s.size.id, name: s.size.name }));

								color.size = size && size.length > 0 ? size[0] : undefined;
								return color;
							});
					}
				}
			});
	}

	close() {
		this.#dialogRef.close(null);
	}

	apply() {
		this.#dialogRef.close({ warehouse: this.warehouse, styles: this.addedStyles });
	}

	openWarehouseFilterModal(): void {
		this.dialog
			.open(FilterListComponent<Warehouse>, {
				data: {
					title: 'Warehouses',
					singleSelection: true,
					selected: this.warehouse
						? [
								{
									...this.warehouse,
									displayId: this.warehouse.id,
									displayName: this.warehouse.description,
									selected: true
								}
							]
						: [],
					filterService: this.warehouseFilterService
				}
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Warehouse>>) => {
					if (res) {
						this.warehouse = res[0];
						this.resetPagination();
						this.getStyles();
					}
				}
			});
	}

	openBrandFilterModal(): void {
		this.dialog
			.open(FilterListComponent<Brand>, {
				data: {
					title: 'Brands',
					selected: this.stylesFilters.brands
						? this.stylesFilters.brands.map((el) => ({
								...el,
								displayId: el.id,
								displayName: el.name,
								selected: true
							}))
						: [],
					filterService: this.brandFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Brand>>) => {
					if (res) {
						this.stylesFilters.brands = res.map((el: any) => new Brand({ id: el.displayId, name: el.displayName }));
						this.resetPagination();
						this.getStyles();
					}
				}
			});
	}

	openStyleCodesFilter() {
		this.dialog
			.open(StringFilterListComponent, {
				data: { title: 'Style Code', selected: this.stylesFilters.styleCode }
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.stylesFilters.styleCode = _.cloneDeep(res);
						this.resetPagination();
						this.getStyles();
					}
				}
			});
	}

	openStatusFilterModal(): void {
		this.dialog
			.open(FilterListComponent<Status>, {
				data: {
					title: 'Statuses',
					selected: this.stylesFilters.statuses
						? this.stylesFilters.statuses.map((el) => ({
								...el,
								displayId: el.id,
								displayName: el.name,
								selected: true
							}))
						: [],
					filterService: this.styleStatusFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Status>>) => {
					if (res) {
						this.stylesFilters.statuses = res.map((el: any) => new Status({ id: el.displayId, name: el.displayName }));
						this.resetPagination();
						this.getStyles();
					}
				}
			});
	}

	openCategoryFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Categories',
					selected:
						this.stylesFilters.categories?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.categoryFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Category>>) => {
					if (res) {
						this.stylesFilters.categories = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.resetPagination();
						this.getStyles();
					}
				}
			});
	}

	openStyleGroupFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Style Groups',
					selected:
						this.stylesFilters.styleGroups?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.styleGroupFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<StyleGroup>>) => {
					if (res) {
						this.stylesFilters.styleGroups = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.resetPagination();
						this.getStyles();
					}
				}
			});
	}

	openStyleDescriptionFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Style Descriptions',
					selected:
						this.stylesFilters.styleDescriptions?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.styleDescriptionFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<StyleDescription>>) => {
					if (res) {
						this.stylesFilters.styleDescriptions = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.resetPagination();
						this.getStyles();
					}
				}
			});
	}

	openCollectionFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Collections',
					selected:
						this.stylesFilters.collections?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.collectionFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Collection>>) => {
					if (res) {
						this.stylesFilters.collections = res.map((el: any) => ({ id: el.displayId, name: el.displayName, startDate: el.startDate, endDate: el.endDate }));
						this.resetPagination();
						this.getStyles();
					}
				}
			});
	}

	openPurposeFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Purposes',
					selected:
						this.stylesFilters.purposes?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.purposeFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Purpose>>) => {
					if (res) {
						this.stylesFilters.purposes = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.resetPagination();
						this.getStyles();
					}
				}
			});
	}

	openGenderFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Genders',
					selected:
						this.stylesFilters.genders?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.genderFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Gender>>) => {
					if (res) {
						this.stylesFilters.genders = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.resetPagination();
						this.getStyles();
					}
				}
			});
	}

	openTeamFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Teams',
					selected:
						this.stylesFilters.teams?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.teamFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Team>>) => {
					if (res) {
						this.stylesFilters.teams = res.map((el: any) => ({ id: el.displayId, name: el.displayName, code: el.code }));
						this.resetPagination();
						this.getStyles();
					}
				}
			});
	}

	cleanFilter(filterType: string): void {
		switch (filterType) {
			case 'brands':
				this.stylesFilters.brands = [];
				break;
			case 'categories':
				this.stylesFilters.categories = [];
				break;
			case 'styleGroups':
				this.stylesFilters.styleGroups = [];
				break;
			case 'styleDescriptions':
				this.stylesFilters.styleDescriptions = [];
				break;
			case 'collections':
				this.stylesFilters.collections = [];
				break;
			case 'purposes':
				this.stylesFilters.purposes = [];
				break;
			case 'genders':
				this.stylesFilters.genders = [];
				break;
			case 'teams':
				this.stylesFilters.teams = [];
				break;
			case 'styleCode':
				this.stylesFilters.styleCode = '';
				break;
			case 'statuses':
				this.stylesFilters.statuses = [];
				break;
		}

		this.resetPagination();
		this.getStyles();
	}

	resetPagination() {
		this.stylesFilters.page = 1;
		this.allLoaded = false;
		this.availablestyles.items = [];
	}
}
